import { transformErrorResponse } from "../../transformErrorResponse"
import { SomacylEntregablesDTO, SomacylOrderENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."
import { IBodyFinalizeOrder } from "../../../../Operaciones/OrdenesSomacyl/FinalizeOrder"
import { IBodySomacyl } from "../../../../Operaciones/OrdenesSomacyl/AddInventory"

export const ESPAÑA_1729_SomacylOrder = (build: AtcApiBuilder) => {
    return {
        getByIdSomacylOrders: build.query<SomacylOrderENTITY[], string>({
            query: (userId) => `procesos/ESPANA_1729_SomacylOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'SomacylOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'SomacylOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'SomacylOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitSomacylOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/ESPANA_1729_SomacylOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventorySomacylOrders: build.mutation<SomacylOrderENTITY, { id: string, body: IBodySomacyl }>({
            query: ({ body, id }) => ({
                url: `procesos/ESPANA_1729_SomacylOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'SomacylOrders' as const, id },
            ],
            transformErrorResponse
        }),
        uploadPhotosSomacylOrders: build.mutation<SomacylOrderENTITY, { id: string, entregables: SomacylEntregablesDTO }>({
            query: ({ entregables, id }) => ({
                url: `procesos/ESPANA_1729_SomacylOrder/upload-photos/${id}`,
                method: "PUT",
                body: { entregables },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'SomacylOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventorySomacylOrders: build.mutation<SomacylOrderENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/ESPANA_1729_SomacylOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'SomacylOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeSomacylOrders: build.mutation<SomacylOrderENTITY, { id: string, body: IBodyFinalizeOrder }>({
            query: ({ id, body }) => ({
                url: `procesos/ESPANA_1729_SomacylOrder/finalize/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'SomacylOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'SomacylOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        })
    }
}